export const SET_ORGANIZATIONS = 'setOrganizations'
export const SET_COLLECTIONS_FOR_URL = 'setCollectionsForUrl'
export const SET_DATES = 'setDates'
export const SET_PAYMENT_INFORMATION_FOR_URL = 'setPaymentInformationForUrl'
export const SET_OVERRIDE = 'setOverride'
export const SET_EXTENSIONS_FOR_PLANS = 'setExtensionsForPlans'

export const SET_ORGANIZATION_AND_COLLECTION = 'setOrganizationAndCollection'
export const UPDATE_TIME = 'updateTime'

export const SET_DEVICE_CONFIGURATION = 'setDeviceConfiguration'
export const SET_APP_MACHINE_ID = 'setAppMachineId'
